import { render, staticRenderFns } from "./NaviGation_ColorCard.vue?vue&type=template&id=5fabb54b&scoped=true"
import script from "./NaviGation_ColorCard.vue?vue&type=script&lang=js"
export * from "./NaviGation_ColorCard.vue?vue&type=script&lang=js"
import style0 from "./NaviGation_ColorCard.vue?vue&type=style&index=0&id=5fabb54b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fabb54b",
  null
  
)

export default component.exports